(function() {
var langCode = ui.langCode;
var lang_url = '/' + (langCode === ui.langm ? '' : langCode + '/');
var domain   = ui.hostm + lang_url;
ui.url = {
  blogfeedback: lang_url + 'blogfeedback',//ajax
  cart        : lang_url + 'cart',
  cartAdd     : domain + 'cartadd',       //ajax
  cashback    : lang_url + 'cashback',
  couponInfo  : domain + 'couponinfo',   //ajax
  notifyMe    : domain + 'notifyme',     //ajax
  orderAdd    : domain + 'orderadd',     //ajax
  orderCheck  : domain + 'ordercheck',   //ajax
  orderFinish : domain + 'orderfinish',  //ajax
  nps         : domain + 'nps',          //ajax
  public_offer: lang_url + 'oferta',
  reviewAdd   : domain + 'reviewadd',    //ajax
  sessionInit : domain + 'sessioninit',  //ajax
  search      : lang_url + 'search#',
  wishToggle  : domain + 'wish',         //ajax
  wishClear   : domain + 'wish_clear'    //ajax
};
})();